import { render, staticRenderFns } from "./RunningCampaignsTable.vue?vue&type=template&id=6fd993ab&scoped=true"
import script from "./RunningCampaignsTable.vue?vue&type=script&lang=ts"
export * from "./RunningCampaignsTable.vue?vue&type=script&lang=ts"
import style0 from "./RunningCampaignsTable.vue?vue&type=style&index=0&id=6fd993ab&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd993ab",
  null
  
)

export default component.exports